import { RouteKeys } from "@/api_framework/api_modals/Routers";
import { ROUTES_MAPPINGS, VIRTUAL_ROUTES_MAPPING } from "@/app/routes";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useEffect, useState } from "react";
import { useUtils } from "./useUtils";
import { useSearchParams } from "react-router-dom";

const EXECEPTION_ROUTES = [
  "INVALID_ACCESS",
  "CONFIGURATION",
  "VMS_SETUP",
  "MAPPED_CLINIC_AND_CITY",
  "CALL_ANALYSIS",
  "VETIC_EMBED",
  "DOCTOR_INVENTORY",
  "PRODUCT_PERSONA_DISCOUNT",
  // Surge pricing is view-for-all; the API decides who can edit.
  "SURGE_PRICING_LIST",
  "SURGE_PRICING_ONBOARD",
  "SURGE_PRICING_PRICE_CHECK",
];

export const useRBACFlagURL = (routeURL: string) => {
  const { cleanURLPathname } = useUtils();
  const [URLSearchParams, _setParams] = useSearchParams();
  const [validView, setValidView] = useState<"VALID" | "INVALID" | "LOADING">("LOADING");
  const userPermissions = useAppSelector((state) => state.auth.userPermissions);

  const getActionIDFromURL = (routeURL: string) => {
    const navRoutes = Object.entries({ ...ROUTES_MAPPINGS });
    const virtualRoutes = Object.entries({ ...VIRTUAL_ROUTES_MAPPING });
    const routeMappings = [...navRoutes, ...virtualRoutes];
    let actionId = "";
    for (let i = 0; i < routeMappings.length; i++) {
      if (routeURL === routeMappings[i][0]) {
        actionId = routeMappings[i][1];
        break;
      } else {
        actionId = "";
      }
    }
    return actionId;
  };

  useEffect(() => {
    if (routeURL === "/app/invalid-access") {
      window.open(`${URLSearchParams.get("redirect_uri")}`, "_self");
    }
  }, []);

  useEffect(() => {
    if (!routeURL || !userPermissions) return;
    if (userPermissions?.role_permission?.actions?.length > 0) {
      const actionId = getActionIDFromURL(cleanURLPathname(routeURL)) as RouteKeys;
      if (EXECEPTION_ROUTES.includes(actionId)) {
        setValidView("VALID");
        return;
      }
      if (userPermissions?.role_permission?.actions?.includes(actionId)) {
        setValidView("VALID");
      } else {
        setValidView("INVALID");
      }
    }
  }, [routeURL, userPermissions]);

  return {
    loadView: validView,
    userPermissions: userPermissions,
    actionId: getActionIDFromURL(cleanURLPathname(routeURL)),
  };
};
